var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderUserExample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 48.9996C13.2885 48.9996 3 38.6985 3 26C3 13.2882 13.2868 3 26 3C38.7118 3 48.9996 13.2868 48.9996 26C48.9996 38.7108 38.6974 48.9996 26 48.9996Z",
    fill: "#66A9DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 3V48.9996C38.6974 48.9996 48.9996 38.7108 48.9996 26C48.9996 13.2871 38.7118 3 26 3Z",
    fill: "#4F84CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 31.3906C19.3081 31.3906 12.9271 34.3162 8.26367 40.6417C17.5502 51.867 34.7395 51.7712 43.9008 40.4413C41.6385 38.191 36.543 31.3906 26.0004 31.3906Z",
    fill: "#D6F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9003 40.4413C39.5752 45.7895 33.0857 48.9996 26 48.9996V31.3906C36.543 31.3906 41.6381 38.1917 43.9003 40.4413Z",
    fill: "#BDECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 27.3477C21.5412 27.3477 17.9141 23.7202 17.9141 19.2617V16.5664C17.9141 12.1079 21.5412 8.48047 26 8.48047C30.4585 8.48047 34.0859 12.1079 34.0859 16.5664V19.2617C34.0859 23.7202 30.4585 27.3477 26 27.3477Z",
    fill: "#D6F3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 8.48047V27.3477C30.4588 27.3477 34.0859 23.7206 34.0859 19.2617V16.5664C34.0859 12.1076 30.4588 8.48047 26 8.48047Z",
    fill: "#BDECFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 26,
    y1: 0,
    x2: 26,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderUserExample);
export default __webpack_public_path__ + "static/media/header-user-example.f67e5f281934eb0c1669378211a691e2.svg";
export { ForwardRef as ReactComponent };